module.exports = __webpack_public_path__ + "static/media/dubaipetroleum.c14fc4fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/dubaipetroleum.png
// module id = 48
// module chunks = 0